import api from "services/api";
import secureLocalStorage from "react-secure-storage";

export interface ICsatResposta {
  perguntaId: number;
  valor: string | null;
}

export interface ICsatRequest {
  cpfCnpj: string;
  contrato: string;
  acordoId: string;
  crmId: string;
  carteiraId: number;
  respostas: ICsatResposta[];
}

export interface ICsatPergunta {
  id: number;
  texto: string;
  tipo: number;
}

export interface ICsatResponse {
  pesquisaId: number;
  perguntas: ICsatPergunta[];
}

export interface ICsatPostResponse {
  sucesso: boolean;
  mensagem: string;
}

const getAuthConfig = () => {
  const token = secureLocalStorage.getItem("@token") as string | null;

  return token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : {};
};

export const registrarCsatService = async (payload: ICsatRequest) => {
  const config = getAuthConfig();

  const { data } = await api.post<ICsatPostResponse>(
    "RegistrarCsat",
    payload,
    config
  );

  return data;
};

export const buscarCsatService = async (): Promise<ICsatResponse> => {
  const config = getAuthConfig();

  const { data } = await api.get<ICsatResponse>(
    "Csat",
    config
  );

  return data;
};